module.exports = __webpack_public_path__ + "static/img/2-01.37ef229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2-01.png
// module id = 175
// module chunks = 1